import { Capacitor } from '@capacitor/core';

export const isNative = (): boolean => Capacitor.isNativePlatform();

export const platform = (): 'web' | 'android' | 'ios' =>
  Capacitor.getPlatform() === 'android'
    ? 'android'
    : Capacitor.getPlatform() === 'ios'
      ? 'ios'
      : 'web';

const configuredApi = import.meta.env.VITE_API_URL;
const nativeApi =
  import.meta.env.VITE_NATIVE_API_URL || 'https://family.p-co.ru/api/v1';

export const API_BASE =
  isNative() && (!configuredApi || !configuredApi.startsWith('http'))
    ? nativeApi
    : configuredApi || '/api/v1';

function socketOrigin(): string | undefined {
  if (import.meta.env.VITE_SOCKET_URL) return import.meta.env.VITE_SOCKET_URL;
  if (API_BASE.startsWith('http')) {
    try {
      return new URL(API_BASE).origin;
    } catch {
      return undefined;
    }
  }
  return undefined;
}

export const SOCKET_URL = socketOrigin();

export function nativeHeaders(): Record<string, string> {
  return isNative() ? { 'X-Client-Platform': platform() } : {};
}
